import moment from 'moment'

export function estimateDeactivationDate(
  instructionDate: string
): moment.Moment {
  const instructionDay = moment(instructionDate)
  return instructionDay.add(15, 'days')
}

export function estimateReinstatedDeactivationDate(): moment.Moment {
  const today = moment(moment().format('YYYY-MM-DD'))
  const lastDayToCompleteCourse = today.add(7, 'days')
  const deactivationDate = lastDayToCompleteCourse.add(1, 'days')
  return deactivationDate
}

export function formatLastDayToCompleteCourse(values: {
  instructionDate?: string
  deactivationDate?: string
}) {
  let lastDay
  if (values.deactivationDate) {
    lastDay = moment(values.deactivationDate).subtract(1, 'days')
  } else if (values.instructionDate) {
    lastDay = estimateDeactivationDate(values.instructionDate)
  }
  return lastDay
    ? `Last day to complete course: ${lastDay.format('MMM Do')}`
    : null
}
// [session]: [day]
const dayBySession = {
  1: 1,
  2: 2,
  3: 3,
  4: 10,
}

export function formatProgress(progress?: string): string | undefined {
  if (!progress || !progress.startsWith('S')) return progress
  const sessionNumber = parseInt(progress.charAt(progress.indexOf('S') + 1))
  const dayNumber = dayBySession[sessionNumber as keyof typeof dayBySession]
  const formatted = `Day ${dayNumber} (${progress})`
  return dayNumber ? formatted : progress
}
